import React from 'react';
import {
  ListItem,
  ListItemIcon,
} from './List';
import CircleIcon from './CircleIcon';
import { styled } from './styled';

const StyledListItem = styled(ListItem)(({ theme, width }) => ({
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.primary.veryLight,
  },
  '& .MuiListItemIcon-root': {
    minWidth: `${width + theme.spacingNum(2)}px`,
  },
}));

const NavListItem = React.forwardRef((props, ref) => {
  const {
    Icon,
    IconProps = {},
    children,
    className,
    itemIconClassName,
    ...listItemProps
  } = props;

  const {
    variant = 'outlined',
    className: iconClassName,
    width = 32,
    ...otherIconProps
  } = IconProps;

  return (
    <StyledListItem ref={ref} button className={className} width={width} {...listItemProps}>
      {Icon && (
        <ListItemIcon
          classes={
            { root: itemIconClassName }
          }
        >
          <CircleIcon
            Icon={Icon}
            variant={variant}
            className={iconClassName}
            fontSize={`${width}px`}
            shrinkFactor='1 / 2'
            {...otherIconProps}
          />
        </ListItemIcon>
      )}
      {
        children
      }
    </StyledListItem>
  );
});

export default NavListItem;
